import React from "react";

const S = {
  card:{background:"#fff",border:"0.5px solid #e0dfd8",borderRadius:12,padding:"16px 20px",marginBottom:16},
  statCard:{background:"#f5f5f0",borderRadius:8,padding:"14px 16px"},
};

export default function Reports() {
  return (
    <div>
      <div style={{fontSize:14,fontWeight:500,marginBottom:14}}>Budgeting & Reports</div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:16}}>
        {[["Revenue YTD","—","#3B6D11"],["Expenses YTD","—","#854F0B"],["Net Profit","—","#185FA5"],["Profit Margin","—","#3B6D11"]].map(([l,v,c])=>(
          <div key={l} style={S.statCard}>
            <div style={{fontSize:12,color:"#888",marginBottom:6}}>{l}</div>
            <div style={{fontSize:22,fontWeight:500,color:c}}>{v}</div>
          </div>
        ))}
      </div>
      <div style={S.card}>
        <div style={{fontSize:13,fontWeight:500,marginBottom:8}}>Reports</div>
        <div style={{fontSize:13,color:"#aaa",padding:"32px 0",textAlign:"center"}}>
          Reports will populate as you add invoices, log time, and record activity.<br/>
          <span style={{fontSize:12}}>Connect QBO to sync financial data automatically.</span>
        </div>
      </div>
    </div>
  );
}
